import React, { Fragment } from "react";
import { Link, Redirect } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { makeStyles } from "@material-ui/core/styles";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";
import {
  TextField,
  FormControl,
  OutlinedInput,
  Input,
  InputLabel,
  InputAdornment,
} from "@material-ui/core";

// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { register } from "../../actions/register";

//components
// import BreadCrumb from "../../components/breadcrumb/breadcrumb";

import Alert from "../../components/alert/alert.component";

const recaptchaRef = React.createRef();

class Register extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      captcha: null,
      firstName: "",
      lastName: "",
      emailConfirmError: false,
      email: "",
      emailConfirm: "",
      phone: "",
      passwordConfirmError: false,
      password: "",
      passwordConfirm: "",
      newsletter: true,
      privacy: true,
      registerSuccess: null,
      firstNameError: "",
      lastNameError: "",
      emailError: "",
      phoneError: "",
      passwordError: "",
    };
  }

  onChange = (value) => {
    this.setState({ captcha: value });
  };

  _changeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  captcha = () =>
    this.state.captcha === null && this.state.privacy === false ? (
      <input
        type="button"
        onClick={this.onSubmit}
        defaultValue="Continue"
        className="create-acc"
        disabled
      />
    ) : (
      <input
        type="button"
        onClick={this.onSubmit}
        defaultValue="Continue"
        className="create-acc"
      />
    );

  onSubmit = async (e) => {
    this.setState({ loading: true });

    const {
      firstName,
      lastName,
      email,
      phone,
      password,
      passwordConfirm,
      newsletter,
    } = this.state;
    window.scrollTo(0, 0);
    if (password !== passwordConfirm) {
      if (password !== passwordConfirm) {
        this.setState({ passwordConfirmError: true });
        setTimeout(() => {
          this.setState({ passwordConfirmError: false });
        }, 5000);
      }
      return;
    }
    if (firstName.length < 4) {
      this.setState({
        firstNameError: "First Name must be at least 4 charactor long",
      });
      return;
    }
    if (lastName.length < 4) {
      this.setState({
        lastNameError: "Last Name must be at least 4 charactor long",
      });
      return;
    }
    const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!regexp.test(email)) {
      this.setState({ emailError: "Enter Valid email" });
      return;
    }
    if (phone.length < 8) {
      this.setState({ phoneError: "Phone is required" });
      return;
    }
    if (password.length < 6) {
      this.setState({
        passwordError: "Password must be at least 6 charactor long",
      });
      return;
    }

    const data = {
      firstName,
      lastName,
      email,
      phone,
      password,
      isSubscribe: newsletter,
    };
    const res = await this.props.register(data);

    if (res) {
      this.setState({ registerSuccess: res.data });
      this.setState({
        captcha: null,
        firstName: "",
        lastName: "",
        emailConfirmError: false,
        email: "",
        emailConfirm: "",
        phone: "",
        passwordConfirmError: false,
        password: "",
        passwordError: "",
        passwordConfirm: "",
        newsletter: "",
      });
    }

    if (res) {
      this.setState({ loading: false });
    }
  };
  handleFirstNameChange = (e) => {
    const target = e.target;
    console.log(target.value.charAt(0));
    /*    console.log(target.charAt(0)); */
    if (
      target.value.charAt(0) === "0" ||
      target.value.charAt(0) === "1" ||
      target.value.charAt(0) === "2" ||
      target.value.charAt(0) === "3" ||
      target.value.charAt(0) === "4" ||
      target.value.charAt(0) === "5" ||
      target.value.charAt(0) === "6" ||
      target.value.charAt(0) === "7" ||
      target.value.charAt(0) === "8" ||
      target.value.charAt(0) === "9" ||
      target.value.length < 3
    ) {
      console.log("handleUsernameChange()");
      this.setState({
        firstName: target.value,
        firstNameError: "Enter Valid First Name",
      });
    } else {
      this.setState({
        firstName: target.value,
        firstNameError: "",
      });
    }
  };
  handleLastNameChange = (e) => {
    const target = e.target;
    if (
      target.value.charAt(0) === "0" ||
      target.value.charAt(0) === "1" ||
      target.value.charAt(0) === "2" ||
      target.value.charAt(0) === "3" ||
      target.value.charAt(0) === "4" ||
      target.value.charAt(0) === "5" ||
      target.value.charAt(0) === "6" ||
      target.value.charAt(0) === "7" ||
      target.value.charAt(0) === "8" ||
      target.value.charAt(0) === "9" ||
      target.value.length < 3
    ) {
      console.log("handleUsernameChange()");
      this.setState({
        lastName: target.value,
        lastNameError: "Enter Valid Last Name",
      });
    } else {
      this.setState({
        lastName: target.value,
        lastNameError: "",
      });
    }
  };
  handleEmailNameChange = (e) => {
    const target = e.target;
    const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!regexp.test(target.value)) {
      this.setState({
        email: target.value,
        emailError: "Enter Valid Email",
      });
    } else {
      this.setState({
        email: target.value,
        emailError: "",
      });
    }
  };
  handlePhoneChange = (e) => {
    const target = e.target;
    if (target.value.length < 9) {
      this.setState({
        phone: target.value,
        phoneError: "Valid Phone Number is required",
      });
    } else {
      this.setState({
        phone: target.value,
        phoneError: "",
      });
    }
  };
  handlePasswordChange = (e) => {
    const target = e.target;
    if (target.value.length < 6) {
      console.log("handleUsernameChange()");
      this.setState({
        password: target.value,
        passwordError: "Password must be at least 6 charactor long",
      });
      console.log(this.state.passwordError);
    } else {
      this.setState({
        password: target.value,
        passwordError: "",
      });
    }
  };
  handleConfirmChange = (e) => {
    const target = e.target;
    if (target.value !== this.state.password) {
      console.log("handleUsernameChange()");
      this.setState({
        passwordConfirm: target.value,
        confirmPasswordError: "Passwords not match",
      });
    } else {
      this.setState({
        passwordConfirm: target.value,
        confirmPasswordError: "",
      });
    }
  };

  // feilds data show or hide

  handleChange = (event) => {
    console.log(event);
    this.setState({ [event.target.name]: event.target.value });
    // setState({ ...this.state.values, [prop]: event.target.value });
  };

  handleClickShowPassword = () => {
    if (this.state.showPassword === false) {
      this.setState({ showPassword: true });
    } else {
      this.setState({ showPassword: false });
    }
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  // end fields data show or hide
  render() {
    const { isAuth } = this.props._auth;
    return isAuth && !this.props._auth.loading ? (
      <Redirect exact to="/dashboard" />
    ) : (
      <Fragment>
        <div className="create-an-account">
          <div className="regester-top">
            <div className="container">
              <div className="row mx-md-5">
                <header className="col-md-12" id="create-acc-header">
                  {/*<strong>
                    <Link
                      className="navbar-brand"
                      to={"/"}
                      id="logo"
                      title="sundialhomeproducts.com"
                    >
                      Sundial
                    </Link>
                  </strong>*/}
                  <span className="secure-login">
                    Secure Login <i className="fa fa-lock" />
                  </span>
                </header>
              </div>
            </div>
          </div>
          <div className="create-account">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div id="acc-container">
                    <div className="create-acc-heading">
                      <h3>Your Personal Details</h3>
                    </div>

                    {this.state.registerSuccess && (
                      <div
                        className="alert alert-success"
                        role="alert"
                        style={{
                          width: "100%",
                          marginBottom: "2%",
                          marginTop: "2%",
                        }}
                      >
                        {this.state.registerSuccess}&nbsp;
                        <a
                          className="default-color"
                          target="_blank"
                          href="https://mail.google.com/mail/u/0/#inbox"
                        >
                          Click Here
                        </a>
                      </div>
                    )}
                    <form action id="registerForm">
                      <FormControl variant="outlined" className="my-2">
                        <TextField
                          variant="outlined"
                          id="component-outlined"
                          name="firstName"
                          value={this.state.firstName && this.state.firstName}
                          onChange={(e) => {
                            this.handleFirstNameChange(e);
                          }}
                          error={
                            this.state.firstNameError &&
                            this.state.firstNameError !== ""
                              ? true
                              : false
                          }
                          label="First Name"
                          helperText={
                            this.state.firstNameError &&
                            this.state.firstNameError
                          }
                        />
                      </FormControl>
                      <FormControl variant="outlined" className="my-2">
                        <TextField
                          variant="outlined"
                          id="component-outlined"
                          name="lastName"
                          maxLength={32}
                          value={this.state.lastName && this.state.lastName}
                          onChange={(e) => {
                            this.handleLastNameChange(e);
                          }}
                          error={
                            this.state.lastNameError &&
                            this.state.lastNameError !== ""
                              ? true
                              : false
                          }
                          label="Last Name"
                          helperText={
                            this.state.lastNameError && this.state.lastNameError
                          }
                        />
                      </FormControl>
                      <FormControl variant="outlined" className="my-2">
                        <TextField
                          variant="outlined"
                          id="component-outlined"
                          type="email"
                          name="email"
                          maxLength={96}
                          value={this.state.email && this.state.email}
                          onChange={(e) => {
                            this.handleEmailNameChange(e);
                          }}
                          error={
                            this.state.emailError &&
                            this.state.emailError !== ""
                              ? true
                              : false
                          }
                          label="Email Address"
                          helperText={
                            this.state.emailError && this.state.emailError
                          }
                        />
                      </FormControl>
                      <FormControl variant="outlined" className="my-2">
                        <TextField
                          variant="outlined"
                          id="component-outlined"
                          type="number"
                          name="phone"
                          maxLength={32}
                          value={this.state.phone && this.state.phone}
                          onChange={(e) => {
                            this.handlePhoneChange(e);
                          }}
                          error={
                            this.state.phoneError &&
                            this.state.phoneError !== ""
                              ? true
                              : false
                          }
                          label="Phone Number"
                          helperText={
                            this.state.phoneError && this.state.phoneError
                          }
                        />
                      </FormControl>

                      {this.state.passwordConfirmError && (
                        <div
                          className="alert alert-danger"
                          role="alert"
                          style={{
                            width: "100%",
                            marginBottom: "1%",
                            marginTop: "3%",
                          }}
                        >
                          Password does not match
                        </div>
                      )}
                      <FormControl variant="outlined" className="my-2">
                        <TextField
                          variant="outlined"
                          id="component-outlined"
                          name="phone"
                          type={this.state.showPassword ? "text" : "password"}
                          maxLength={32}
                          value={this.state.password && this.state.password}
                          onChange={(e) => {
                            this.handlePasswordChange(e);
                          }}
                          error={
                            this.state.passwordError &&
                            this.state.passwordError !== ""
                              ? true
                              : false
                          }
                          label="Create Password"
                          helperText={
                            this.state.passwordError && this.state.passwordError
                          }
                        />
                      </FormControl>
                      {/*     <FormControl variant="outlined" className="my-2">
                        <InputLabel htmlFor="outlined-adornment-password">Create Password</InputLabel>
                        <OutlinedInput
                          id="outlined-adornment-password"
                          type={this.state.showPassword ? 'text' : 'password'}
                          autoComplete="new-password"
                          name="password"
                          value={this.state.password && this.state.password}
                          maxLength={20}
                          onChange={(e) => {
                            this.handlePasswordChange(e);
                          }}
                          error={this.state.passwordError && this.state.passwordError !== '' ? true: false}
                          label="Create Password"
                          helperText={this.state.passwordError && this.state.passwordError}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={this.handleClickShowPassword}
                                onMouseDown={this.handleMouseDownPassword}
                                edge="end"
                              >
                                {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl> */}
                      <FormControl variant="outlined" className="my-2">
                        <TextField
                          variant="outlined"
                          id="component-outlined"
                          name="passwordConfirm"
                          type={this.state.showPassword ? "text" : "password"}
                          value={
                            this.state.passwordConfirm &&
                            this.state.passwordConfirm
                          }
                          onChange={(e) => {
                            this.handleConfirmChange(e);
                          }}
                          error={
                            this.state.confirmPasswordError &&
                            this.state.confirmPasswordError !== ""
                              ? true
                              : false
                          }
                          label="Confirm Password"
                          helperText={
                            this.state.confirmPasswordError &&
                            this.state.confirmPasswordError
                          }
                        />
                      </FormControl>
                      {/*   <FormControl variant="outlined" className="my-2">
                        <InputLabel htmlFor="outlined-adornment-password">Confirm Password</InputLabel>
                        <OutlinedInput
                          id="outlined-adornment-password"
                          type={this.state.showPassword ? 'text' : 'password'}
                          name="passwordConfirm"
                          value={
                            this.state.passwordConfirm &&
                            this.state.passwordConfirm
                          }
                          onChange={(e) => {
                            this.handleConfirmChange(e);
                          }}
                          error={this.state.confirmPasswordError &&
                            this.state.confirmPasswordError !== '' ? true: false}
                          label="Confirm Password"
                          helperText={this.state.confirmPasswordError &&
                            this.state.confirmPasswordError}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={this.handleClickShowPassword}
                                onMouseDown={this.handleMouseDownPassword}
                                edge="end"
                              >
                                {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl> */}
                      <div className="create-acc-newsLetter">
                        <h3 className="sub-acc-news">Newsletter</h3>
                        <div className="sub-new-inps">
                          <label className="radio-inline sub-yes-no">
                            <input
                              type="radio"
                              name="newsletter"
                              id="yesNews"
                              checked="true"
                              onChange={(e) => {
                                this.setState({ newsletter: true });
                              }}
                            />
                            <span className="create-acc-placeholder">Yes</span>
                          </label>
                          <label className="radio-inline sub-yes-no">
                            <input
                              type="radio"
                              name="newsletter"
                              id="noNews"
                              onChange={(e) => {
                                this.setState({ newsletter: false });
                              }}
                            />
                            <span className="create-acc-placeholder">No</span>
                          </label>
                        </div>
                      </div>
                      <div className="create-acc-email">
                        <label className="col-sm-2 control-label"> </label>
                        <div className="col-sm-10">
                          <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
                            onChange={this.onChange}
                          />
                        </div>
                      </div>

                      <div className="create-acc-btn">{this.captcha()}</div>
                      <div className="form-footer">
                        <div className="create-acc-email"></div>
                        <p className="acc-agree">
                          By creating an account, you are agreeing to our{" "}
                          <Link to={"/privacy-policy"}> privacy policy </Link>{" "}
                          and{" "}
                          <Link to={"/term-conditions"}> terms of use </Link>.
                        </p>
                        <p className="hav-acc">
                          Have an account?{" "}
                          <Link to={"/login"} id="signIn-acc">
                            Sign In
                          </Link>
                        </p>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

register.propTypes = {
  register: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  _auth: state.auth,
});

export default connect(mapStateToProps, { register })(Register);
